import { createAction } from '@reduxjs/toolkit';

export const showAside = createAction('aside/show');
export const hideAside = createAction('aside/hide');
export const toggleAside = createAction<boolean, 'aside/toggle'>('aside/toggle');
